<template>
  <!-- eslint-disable vue/no-mutating-props -- account is a nested reactive object from parent form state, bound via v-model -->
  <fieldset>
    <div class="group">
      <div class="field">
        <label :for="fieldId('account', index, 'firstname')">{{ $t('firstname') }}</label>
        <div>
          <input
            :id="fieldId('account', index, 'firstname')"
            type="text"
            name="firstname"
            :autocomplete="index === 0 ? 'given-name' : ''"
            :readonly="isAccountUpdate"
            v-model="account.firstname"
          />
          <v-form-error :error="errors[`accounts.${index}.firstname`]" />
        </div>
      </div>

      <div v-if="showInsertion" class="field insertion">
        <label :for="fieldId('account', index, 'insertion')">{{ $t('insertion') }}</label>
        <div>
          <input
            :id="fieldId('account', index, 'insertion')"
            type="text"
            v-model="account.insertion"
            :readonly="isAccountUpdate"
          />
          <v-form-error :error="errors[`accounts.${index}.insertion`]" />
        </div>
      </div>

      <div class="field">
        <label :for="fieldId('account', index, 'lastname')">{{ $t('lastname') }}</label>
        <div>
          <input
            :id="fieldId('account', index, 'lastname')"
            type="text"
            name="lastname"
            :readonly="isAccountUpdate"
            :autocomplete="index === 0 ? 'family-name' : ''"
            v-model="account.lastname"
          />
          <v-form-error :error="errors[`accounts.${index}.lastname`]" />
        </div>
      </div>
    </div>

    <div class="group">
      <div class="field">
        <label :for="fieldId('account', index, 'email')">{{ $t('email') }}</label>
        <div>
          <template v-if="isAccountUpdate">
            <span class="input-display" readonly>{{ account.email }}</span>
          </template>
          <template v-else>
            <input
              :id="fieldId('account', index, 'email')"
              type="email"
              name="email"
              required
              v-model="account.email"
              v-on:change="emit('validate-email', index)"
            />
            <span
              class="did-you-mean"
              v-if="didYouMean.has(index)"
              v-on:click.prevent="emit('apply-did-you-mean', index)"
            >
              {{ $t('Did you mean') }} <strong>{{ didYouMean.get(index) }}</strong
              >?
            </span>
            <v-form-error :error="errors[`accounts.${index}.email`]" />
          </template>
        </div>
      </div>

      <div class="field">
        <label :for="fieldId('account', index, 'phone')">{{ $t('cellphone') }}</label>
        <div>
          <vue-tel-input
            v-model="account.phone"
            :input-options="{ id: fieldId('account', index, 'phone'), placeholder: '' }"
            autocomplete="tel"
            default-country="nl"
          ></vue-tel-input>
          <v-form-error :error="errors[`accounts.${index}.phone`]" />
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script lang="ts" setup>
import { useRegistrationContext } from '/@front:shared/composables/useRegistrationContext'
import type { Account } from '/@front:shared/registration'
import { fieldId } from '/@front:shared/utils'

withDefaults(
  defineProps<{
    account: Account
    index: number
    errors: Record<string, string>
    isAccountUpdate?: boolean
  }>(),
  {
    isAccountUpdate: false,
  },
)

const emit = defineEmits<{
  (e: 'validate-email', index: number): void
  (e: 'apply-did-you-mean', index: number): void
}>()

const { showInsertion, didYouMean } = useRegistrationContext()
</script>
